// Export as array since these are individual routes, not a group
export default [
  {
    path: "/dashboard",
    name: "dashboard",
    component: () =>
      import(/* webpackChunkName: "dashboard" */ "@/views/DashboardView.vue"),
    meta: {
      title: "dashboard",
      header: { show: true },
      navbar: { show: true },
      footer: { show: true },
      requiresAuth: true,
      requiredRole: 0,
    },
  },
  {
    path: "/settings",
    name: "settings",
    component: () =>
      import(/* webpackChunkName: "settings" */ "@/views/OptionsView.vue"),
    meta: {
      title: "options",
      header: { show: true },
      navbar: { show: true },
      footer: { show: true },
    },
  },
  {
    path: "*",
    name: "not-found",
    component: () =>
      import(/* webpackChunkName: "not-found" */ "@/views/NotFoundView.vue"),
    meta: {
      title: "not-found",
      header: { show: false },
      navbar: { show: false },
      footer: { show: false },
    },
  },
];
